<div class="h-screen w-full mosaic-dark">
  <router-outlet />
</div>
